import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Reports_custom_ds_get_order_by_order_id_rptService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { order_id: number }): 
  Promise<{ result: { Id?: number, LookupCode?: string, ShipmentOrderLookups?: { OrderId?: number, ShipmentId?: number, Shipment?: { Id?: number, LoadContainerId?: number, LookupCode?: string, Surveys?: { id?: number, contextAppointmentId?: number, contextData?: string, contextLicensePlateId?: number, contextLocationId?: number, contextProjectId?: number, contextShipmentId?: number, contextShippingContainerId?: number, contextTaskId?: number, createdSysDateTime?: string, createdSysUser?: string, equipmentId?: number, modifiedSysDateTime?: string, modifiedSysUser?: string, operationContextData?: string, operationContextTypeId?: number, surveyDefinitionId?: number, version?: string, Inputs?: { id?: number, inputText?: string, surveyElementId?: number, surveyId?: number, Element?: { id?: number, text?: string } }[], SurveyDefinition?: { id?: number, name?: string }, OperationContextType?: { Id?: number, Name?: string }, Equipment?: { Id?: number, LookupCode?: string } }[], LoadContainer?: { Id?: number, LookupCode?: string } } }[] } }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.order_id)) {
      $missingRequiredInParams.push('\'order_id\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      order_id: number    }) {
        if(isNil($inParams.order_id)) {
          return true; 
        }
      return false;
    }
}
